import { trackEvent } from '@/wdm-common/Analytics/umami';

export const initTracking = () => {
    // Listen for clicks on .app-badges__badge--ios elements.
    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('app-badges__badge--ios')) {
            trackEvent('ios-badge-click');
        }

        if (event.target.classList.contains('app-badges__badge--android')) {
            trackEvent('android-badge-click');
        }

        if (event.target.classList.contains('app-badges__badge--chrome')) {
            trackEvent('chrome-badge-click');
        }
    });
};
